import { render, staticRenderFns } from "./CreateNewModalOld.vue?vue&type=template&id=a35848ce&scoped=true&lang=pug"
import script from "./CreateNewModalOld.vue?vue&type=script&lang=js"
export * from "./CreateNewModalOld.vue?vue&type=script&lang=js"
import style0 from "./CreateNewModalOld.vue?vue&type=style&index=0&id=a35848ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35848ce",
  null
  
)

export default component.exports